import axios from "axios";
import { GET_TOKEN } from "./constant";

export function capitalizeWords(str) {
  return str
    .split(/(\s|\,|\.)/) // Pisahkan string berdasarkan spasi, koma, atau titik
    .map((word) => {
      // Kapitalisasi huruf pertama dari setiap kata dan setelah setiap tanda baca (, .)
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join("");
}

export function removeCommas(str) {
  return str.replace(/,/g, "");
}

export function hitungSelisihWaktu(waktuMasuk, waktuPulang) {
  // Mengubah waktu ke objek Date (format aman untuk iOS/Safari)
  if (waktuMasuk !== "" && waktuPulang !== "") {
    const normalize = (t) => {
      const parts = String(t).split(":");
      const hh = parts[0] || "00";
      const mm = parts[1] || "00";
      const ss = parts[2] || "00";
      return `${hh.padStart(2, "0")}:${mm.padStart(2, "0")}:${ss.padStart(
        2,
        "0"
      )}`;
    };

    const waktuAwal = new Date(`1970-01-01T${normalize(waktuMasuk)}`);
    const waktuAkhir = new Date(`1970-01-01T${normalize(waktuPulang)}`);

    if (Number.isNaN(waktuAwal.getTime()) || Number.isNaN(waktuAkhir.getTime())) {
      return "00:00";
    }

    // Menghitung selisih dalam milidetik dan konversi ke menit
    const selisih = (waktuAkhir - waktuAwal) / 1000 / 60;

    // Menghitung jam dan menit
    const jam = Math.floor(selisih / 60);
    const menit = selisih % 60;

    // Mengembalikan waktu dalam format "hh:mm"
    return `${jam.toString().padStart(2, "0")}:${menit
      .toString()
      .padStart(2, "0")}`;
  } else {
    return "00:00";
  }
}

export const refreshToken = async (setAccessToken, history) => {
  try {
    // Konfigurasi axios untuk mengirim cookie
    const response = await axios.get(
      "https://smartdh.rotendaokab.go.id/api/admin/token/tokenku",
      {
        withCredentials: true, // Mengirim cookie ke backend
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );

    setAccessToken(response.data.accessToken);
  } catch (error) {
    if (error.response) {
      // dispatch(logOutUser(history));
      // history.push("/");
      console.log("errrorrr acces token", error.response.data);
    } else {
      console.log("Network error:", error.message);
    }
  }
};
